import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.accountTitleBalanceCurrency.query,
    method: 'post',
    data: requestBody
  })
}

// 获取使用的币种
export function getUsedCurrency(requestBody) {
  return request({
    url: URL.finance.accountTitleBalanceCurrency.getUsedCurrency,
    method: 'post',
    data: requestBody
  })
}

// 获取使用的币种及会计期间
export function getUsedCurrencyAndFiscalPeriod(requestBody) {
  return request({
    url: URL.finance.accountTitleBalanceCurrency.getUsedCurrencyAndFiscalPeriod,
    method: 'post',
    data: requestBody
  })
}

// 获取余额币种
export function loadAccountTitleBalanceCurrencies(requestBody) {
  return request({
    url: URL.finance.accountTitleBalanceCurrency.loadAccountTitleBalanceCurrencies,
    method: 'post',
    data: requestBody
  })
}

// 获取详情
export function detail(requestBody) {
  return request({
    url: URL.finance.accountTitleBalanceCurrency.detail,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存
export function save(requestBody) {
  return request({
    url: URL.finance.accountTitleBalanceCurrency.save,
    method: 'post',
    data: requestBody
  })
}

// 删除
export function remove(requestBody) {
  return request({
    url: URL.finance.accountTitleBalanceCurrency.remove,
    method: 'post',
    data: requestBody
  })
}

// 保存期初余额币种
export function saveBachAccountTitleBalanceCurrency(requestBody) {
  return request({
    url: URL.finance.accountTitleBalanceCurrency.saveBachAccountTitleBalanceCurrency,
    method: 'post',
    data: requestBody
  })
}
